import type { State } from './state'
import type { GetterTree } from 'vuex'

export const getters = {
  isLoggedIn(state: State): boolean {
    return state.apiToken !== undefined
  },

  apiToken(state: State): Maybe<APIToken> {
    return state.apiToken
  },
} as GetterTree<State, State>
